import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { TabView, TabPanel } from "primereact/tabview";
import { useNavigate } from "react-router-dom";
import CommonConfig from "../../../utils/constant";
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import { useCatchResponse } from '../../../utils/useCatchResponse';
import { Dropdown } from "primereact/dropdown";


const GraceMarks = () => {
    const { catchResponse } = useCatchResponse();
    const [searchTerm, setSearchTerm] = useState("");
    const [activeTab, setActiveTab] = useState(0);
    const navigate = useNavigate();
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [coScholasticOnGoingGradesList, setGraceMarksOnGoingGradesList] = useState([]);
    const [coScholasticCompletedGradesList, setGraceMarksCompletedGradesList] = useState([]);
    const [selectedYear, setSelectedYear] = useState('');
    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
    };
    const filteredExams = (activeTab === 1 ? coScholasticCompletedGradesList : coScholasticOnGoingGradesList).filter(x =>
        x?.ClassName?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
        x?.TermName?.toLowerCase()?.includes(searchTerm?.toLowerCase())
    );

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        getFinancialYearData(CommonConfig.isOrgOwner(loginData?.UserRole) ? loginData?._id : loginData?.CreatedBy, loginData);
    }, []);

    const getFinancialYearData = async (id) => {
        const years = await CommonConfig.getFinancialYears(id);
        const currentYear = CommonConfig.getCurrentFinancialYear(years);
        const selectedAcYear = CommonConfig.getCookie('selectedAcademicYear');
        setSelectedYear(selectedAcYear ?? currentYear?.value);
        await GetGraceMarksList(id, id, selectedAcYear ?? currentYear?.value);
    }

    const onGlobalFilterChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const GetGraceMarksList = async (id, schId, financialId) => {
        try {
            let data = {
                UserID: id,
                SchoolId: schId,
                FinancialYearId: financialId
            }
            Loader.show();
            await api.post(APIConstant.path.GetGraceMarksMasterDetailList, data).then(async response => {
                let res = response;
                if (res.success) {
                    var onGoingList = res?.data.filter(x => x?.IsAllow === true);
                    var completeList = res?.data.filter(x => x?.IsAllow === false);
                    setGraceMarksOnGoingGradesList(onGoingList);
                    setGraceMarksCompletedGradesList(completeList);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            Loader.hide();
            console.log(err);
            catchResponse(err);
        }
    }

    const actionTemplate = (rowData) => (
        <Button icon="pi pi-plus-circle" tooltip="Grace Marks" tooltipOptions={{ position: 'top', showOnDisabled: true }} className="e-sction-btn p-m-0" disabled={rowData?.TotalStudents == '0' ? true : false} onClick={(e) => navigate('/grace-marks-entry', { state: { className: rowData?.ClassName, classId: rowData?.ClassId, termId: rowData?.TermId, financialId: selectedYear } })} />
    );

    const srNoBodyTemplate = (data, props) => {
        return props?.rowIndex + 1;
    };

    return (
        <div className='wayment-owner-dashboard et-master-page'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-check-square"></i>
                    <h2>Grace Marks</h2>
                </div>
                <div className="e-tab-main p-ml-2 p-d-flex p-jc-center p-ai-center" style={{ flex: 1, height: 'auto', flexDirection: 'row', display: 'flex' }}>
                    <ul className="p-tabview-nav" style={{ margin: 0, padding: 0, border: 'none', background: 'none' }}>
                        <li className={activeTab === 0 ? "p-highlight" : ""} onClick={() => setActiveTab(0)}>
                            <a className="p-tabview-nav-link" style={{ cursor: 'pointer', backgroundColor: activeTab === 0 ? '#4e8ba5' : '', color: activeTab === 0 ? '#FFFFFF' : '' }}>
                                <span className="p-tabview-title" style={{ color: activeTab === 0 ? '#FFFFFF' : '' }}>Ongoing</span>
                            </a>
                        </li>
                        <li className={activeTab === 1 ? "p-highlight" : ""} onClick={() => setActiveTab(1)}>
                            <a className="p-tabview-nav-link" style={{ cursor: 'pointer', backgroundColor: activeTab === 1 ? '#4e8ba5' : '', color: activeTab === 1 ? '#FFFFFF' : '' }}>
                                <span className="p-tabview-title" style={{ color: activeTab === 1 ? '#FFFFFF' : '' }}>Completed</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="p-d-flex p-ai-center p-jc-between">
                    <div className="searchbar-area e-searchbar-area">
                        <i className="pi pi-search" />
                        <InputText
                            value={searchTerm}
                            onChange={onGlobalFilterChange}
                            placeholder="Global Search"
                        />
                    </div>
                </div>
            </div>
            <>
                {activeTab === 0 && (
                    <DataTable value={filteredExams} paginator
                        rows={rows}
                        first={first}
                        responsiveLayout="scroll"
                        paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                        rowsPerPageOptions={[5, 10, 20]}
                        currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records"
                        onPage={onPageChange}
                        className='custom-table'
                        scrollHeight='calc(100vh - 120px)'
                        size='small'
                    >
                        <Column header="Sr No" body={srNoBodyTemplate} style={{ maxWidth: "10%" }} />
                        <Column field="ClassName" header="Class" style={{ maxWidth: "20%" }} />
                        <Column field="TotalStudents" header="No. of Students Require GM" style={{ maxWidth: "17%" }} />
                        <Column field="TermName" header="Term" style={{ maxWidth: "20%" }} />
                        <Column header="Action" headerClassName='e-template-action' bodyClassName='e-template-action' body={actionTemplate} style={{ maxWidth: "10%" }} />
                    </DataTable>
                )}
                {activeTab === 1 && (
                    <DataTable value={filteredExams} paginator
                        rows={rows}
                        first={first}
                        responsiveLayout="scroll"
                        paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                        rowsPerPageOptions={[5, 10, 20]}
                        currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records"
                        onPage={onPageChange}
                        className='custom-table'
                        scrollHeight='calc(100vh - 120px)'
                        size='small'
                    >
                        <Column header="Sr No" body={srNoBodyTemplate} style={{ width: "6%" }} />
                        <Column field="ClassName" header="Class" />
                        <Column field="TotalStudents" header="No. of Students Require GM" />
                        <Column field="TermName" header="Term" />
                        <Column header="Action" headerClassName='e-template-action' bodyClassName='e-template-action' body={actionTemplate} />
                    </DataTable>
                )}
            </>
        </div>
    );
};

export default GraceMarks;
